import { RadioOption } from "@/forms/components";

// ── Re-use shared options from PRIV where fields are identical ────────────────
export {
  COUNTRY_OPTIONS,
  KNOWLEDGE_COLUMNS,
  EXPERIENCE_COLUMNS,
  ESG_PREF_OPTIONS,
  INCOME_STABILITY_OPTIONS,
  INVESTMENT_HORIZON_OPTIONS,
  INVESTMENT_GOAL_OPTIONS,
  RISK_COMFORT_OPTIONS,
  LIQUIDITY_OPTIONS,
  MARKET_FALL_OPTIONS,
  MARKET_DROP_RESPONSE_OPTIONS,
  INVESTMENT_EXPERIENCE_OPTIONS,
  MIFID_INSTRUMENT_ROWS,
  TRADING_FREQUENCY_COLUMNS,
  PERIOD_COLUMNS,
  MIFID_EXPERIENCE_EDUCATION_OPTIONS,
  DEBT_BURDEN_OPTIONS,
} from "../kycPriv/KycPrivForm.options";

// ── Selskapsdata ──────────────────────────────────────────────────────────────

export const YES_NO_OPTIONS: RadioOption[] = [
  { label: "Ja", value: "Ja" },
  { label: "Nei", value: "Nei" },
];

// ── Antihvitvasking (ORG-spesifikke alternativer) ─────────────────────────────

export const ORG_BUSINESS_TYPE_OPTIONS: RadioOption[] = [
  {
    label: "Investerings-/Holdingselskap",
    value: "Investerings-/Holdingselskap",
  },
  { label: "Konsulenttjenester", value: "Konsulenttjenester" },
  { label: "Varehandel", value: "Varehandel" },
  { label: "Servicenæring", value: "Servicenæring" },
  { label: "Annet", value: "other" },
];

export const ORG_PURPOSE_OPTIONS: RadioOption[] = [
  { label: "Investering", value: "Investering" },
  { label: "Annet", value: "other" },
];

export const PORTFOLIO_SIZE_OPTIONS: RadioOption[] = [
  { label: "0 til 5 MNOK", value: "0 til 5 MNOK" },
  { label: "5 til 10 MNOK", value: "5 til 10 MNOK" },
  { label: "10 til 25 MNOK", value: "10 til 25 MNOK" },
  { label: "Mer enn 25 MNOK", value: "Mer enn 25 MNOK" },
];

export const ANNUAL_DEPOSITS_OPTIONS: RadioOption[] = [
  { label: "Mindre enn 10", value: "Mindre enn 10" },
  { label: "10-50", value: "10-50" },
  { label: "Over 50", value: "Over 50" },
];

export const NET_WEALTH_OPTIONS: RadioOption[] = [
  { label: "0–5 MNOK", value: "0-5 MNOK" },
  { label: "5–10 MNOK", value: "5-10 MNOK" },
  { label: "10–25 MNOK", value: "10-25 MNOK" },
  { label: "25–100 MNOK", value: "25-100 MNOK" },
  { label: "> 100 MNOK", value: ">100 MNOK" },
];

export const CAPITAL_NEED_OPTIONS: RadioOption[] = [
  { label: "< 250K", value: "under 250K" },
  { label: "250K–1 MNOK", value: "250K-1MNOK" },
  { label: "1–3 MNOK", value: "1-3MNOK" },
  { label: "> 3 MNOK", value: "Mer enn 3MNOK" },
];

export const ORG_SOURCE_OF_FUNDS_OPTIONS: RadioOption[] = [
  { label: "Oppsparte midler", value: "Oppsparte midler" },
  {
    label: "Salg av virksomhet eller fast eiendom",
    value: "Salg av virksomhet eller fast eiendom",
  },
  { label: "Andre investeringer", value: "Andre investeringer" },
  { label: "Overskuddslikviditet", value: "Overskuddslikviditet" },
  { label: "Annet", value: "other" },
];

export const ORG_SOURCE_OF_WEALTH_OPTIONS: RadioOption[] = [
  { label: "Oppsparte midler", value: "Oppsparte midler" },
  { label: "Arv", value: "Arv" },
  { label: "Salg av virksomhet", value: "Salg av virksomhet" },
  { label: "Annet", value: "other" },
];

/** Ja/Nei (direkte verdier) */
export const YES_NO_DIRECT_OPTIONS: RadioOption[] = [
  { label: "Ja", value: "Ja" },
  { label: "Nei", value: "Nei" },
];

/** Nei/Ja (Ja = "other" – overføring til/fra utland) */
export const NO_YES_OTHER_OPTIONS: RadioOption[] = [
  { label: "Nei", value: "Nei" },
  { label: "Ja", value: "other" },
];

export const CRYPTO_OPTIONS: RadioOption[] = [
  { label: "Nei", value: "Nei" },
  { label: "Ja", value: "Ja" },
];

export const ESG_PREF_TYPE_OPTIONS: RadioOption[] = [
  {
    label: "Preferanse 1 – Bærekraftige investeringer (SFDR art. 8/9)",
    value: "1",
  },
  { label: "Preferanse 2 – EU-taksonomi-tilpassede investeringer", value: "2" },
  {
    label: "Preferanse 3 – Hensyn til negative bærekraftsvirkninger (PAI)",
    value: "3",
  },
  { label: "Preferanse 4 – Kombinasjon av preferansene over", value: "4" },
];

export const ORG_INVESTMENT_HORIZON_OPTIONS: RadioOption[] = [
  { label: "Under ett år", value: "Under ett år" },
  { label: "Fra 1 – 5 år", value: "Fra 1-5 år" },
  { label: "5 – 10 år", value: "5-10 år" },
  { label: "Mer enn 10 år", value: "Mer enn 10 år" },
];

export const ORG_RISK_COMFORT_OPTIONS: RadioOption[] = [
  { label: "Lav", value: "1" },
  { label: "Moderat", value: "2" },
  { label: "Høy", value: "3" },
  { label: "Offensiv", value: "4" },
];

export const ORG_LIQUIDITY_OPTIONS: RadioOption[] = [
  { label: "Høyt", value: "Høyt" },
  { label: "Moderat", value: "Moderat" },
  { label: "Lavt", value: "Lavt" },
  { label: "Svært lavt", value: "Svært lavt" },
];

export const ORG_INVESTMENT_GOAL_OPTIONS: RadioOption[] = [
  { label: "Kapitalbevaring", value: "1" },
  { label: "Stabil avkastning", value: "2" },
  { label: "Moderat vekst", value: "3" },
  { label: "Langsiktig vekst", value: "4" },
];
